import { call, put } from 'redux-saga/effects';

import * as action from '../../actions';
import * as actNotif from '../../actions/notifications';
import { invoicesPageRequest } from '../../actions/reports/invoicesv2';

import * as api from '../../api/invoices';
import { assertErrorHasMessage } from '../../utils/assert';

/**
 * Fetch invoices from the server
 * @param {object} params
 * @returns {*} invoices from server, or false if the request fails
 */
export function* getInvoices(params) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());

  try {
    const response = yield call(api.getInvoices, params);
    return response.data;
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
    return false;
  } finally {
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
  }
}

/**
 * Fetch receipt invoices info from the server
 * @param {object} params
 * @returns {*} receipt invoices info from server, or false if the request fails
 */
export function* getReceiptInvoices(
  id: number,
  uuid: string,
  params?: Record<string, unknown>
) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());

  try {
    const response = yield call(api.getReceiptInvoices, id, uuid, params);
    return response.data;
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
    return false;
  } finally {
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
  }
}

export function* createRecordPayment(data, outletId) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());

  try {
    const response = yield call(api.createRecordPayment, data, outletId);
    // refresh page
    yield put(invoicesPageRequest());
    return response.data;
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
    return false;
  } finally {
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
  }
}

export function* resendEmail(invoiceId: number, invoiceUuid: string) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());

  try {
    const response = yield call(api.resendEmail, invoiceId, invoiceUuid);
    return response;
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
    return false;
  } finally {
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
  }
}
